import React, { useEffect, useState } from "react";
import Sidebar from "../../../components/sidebar";
import { useOutletContext } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import { contactSupport, getUserInfo } from "../../../core/data/redux/contactSupport/_contactSupportAction";
import { supportIssueCategoryOptions } from "../../../constants/utlis";
import UploadIcon from "../../../icons/UploadIcon";
import FileUploadWhiteIcon from "../../../icons/FileUploadWhiteIcon";
import { getStorageItem } from "../../../services/storage.service";

const CustomerSupport = () => {
  const { isSidebarOpen } = useOutletContext<{ isSidebarOpen: boolean; onToggleSidebar: () => void }>();
  const dispatch: any = useDispatch();

  const contactSupportDetails = useSelector((state: any) => state?.contactSupport);
  const contactSupportData = contactSupportDetails?.contactSupportData || {};

  const [issueCategoryOptions] = useState(supportIssueCategoryOptions);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [description, setDescription] = useState("");
  const [uploadError, setUploadError] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);

  const MAX_FILES = 5;

  const userDetail: any = getStorageItem("userData") || null;
  const userData = userDetail !== null ? JSON.parse(userDetail) : null;
  const planPermission = userData?.plan_permissions;
  const fullEmailSupportPermission = planPermission?.permissions?.full_email_support;


  useEffect(() => {
    dispatch(getUserInfo({}))
  }, [dispatch]);


  const handleSubmit = () => {
    const formData: any = new FormData();

    formData.append("category", selectedCategory);
    formData.append("message", description);

    // Append multiple uploaded documents
    uploadedFiles.forEach((file) => {
      formData.append("documents", file);
    });

    // Append user info from Redux if required
    formData.append("subscription_type", contactSupportData?.subscription_name || "");

    console.log("Final FormData Payload >> ");

    for (let pair of formData.entries()) {
      console.log(pair[0] + ": ", pair[1]);
    }

    dispatch(contactSupport(formData));
  };



  return (
    <div className="layout">
      <Sidebar isOpen={isSidebarOpen} />
      <main className="content">
        <div className="contact-support-page">
          <div className=" rounded contact-support-report-page-inner">
            <div className="support-wrapper rounded">
              <h2 className="fw-bold mb-1">{fullEmailSupportPermission ? "Contact Support" : "CPA Contact Support"}</h2>

              <p className="help text-muted small mb-4">
                We’re here to help! Please share the details of your issue, and
                our support team will get back to you by email.
              </p>

              {/* User Information */}
              <h4 className="user fw-bold mb-3">User Information</h4>
              <div className="row g-3 mb-4">
                <div className="col-md-6">
                  <label className="form-label small text-muted">
                    User Name
                  </label>
                  <input
                    type="text"
                    className="input commonInput form-control"
                    placeholder="Olivia Rhye"
                    value={contactSupportData?.name}
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label small text-muted">
                    User Email Id
                  </label>
                  <input
                    type="email"
                    className="input commonInput form-control"
                    placeholder="Olivia@gmail.com"
                    value={contactSupportData?.email}
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label small text-muted">
                    User Mobile Number
                  </label>
                  <input
                    type="text"
                    className="input commonInput form-control"
                    placeholder="+(555) 123-4567"
                    value={contactSupportData?.phone_number}
                    disabled
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label small text-muted">
                    Subscription Type
                  </label>
                  <input
                    type="text"
                    className="input commonInput form-control"
                    placeholder="Basic / Pro / Investor"
                    value={contactSupportData?.subscription_name}
                    disabled
                  />
                </div>
              </div>

              {/* Support Request Details */}
              <h4 className="user fw-bold mb-3">Support Request Details </h4>
              <div className="row g-3">
                <div className="col-md-12">
                  <label className="form-label small text-muted">
                    Issue Category
                  </label>

                  <select
                    className="form-select form-control commonInput bg-light"
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                  >
                    <option value="" disabled hidden>
                      Select an issue
                    </option>

                    {issueCategoryOptions.map((category) => (
                      <option key={category.value} value={category.value}>
                        {category.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-12">
                  <label className="form-label small text-muted">
                    Description Box
                  </label>
                  <textarea
                    rows={4}
                    className="form-control"
                    placeholder="Enter your issue"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  ></textarea>
                </div>

                {/* File Upload */}
                <div className="border rounded p-3 mb-4 button bg-light Enhanced-Information-Section">
                  <div className="mb-3 upload-section">
                    <label className="form-label d-flex justify-content-left align-items-center gap-2">
                      <UploadIcon />
                      File Upload
                    </label>

                    <div
                      className="upload-area rounded text-center p-5 bg-white"
                      style={{
                        borderStyle: "dashed",
                        borderWidth: "2px",
                        borderColor: "#dee2e6",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document.getElementById("fileUploadInput")?.click()
                      }
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (e.dataTransfer.files) {
                          const newFiles = Array.from(e.dataTransfer.files);
                          if (
                            uploadedFiles.length + newFiles.length > MAX_FILES
                          ) {
                            setUploadError(
                              `You can only upload up to ${MAX_FILES} files.`
                            );
                            return;
                          }
                          setUploadedFiles((prev) => [...prev, ...newFiles]);
                          setUploadError("");
                        }
                      }}
                    >
                      <FileUploadWhiteIcon />
                      <p className="mb-0 text-muted">
                        Click or drag file to this area to upload
                      </p>

                      <input
                        type="file"
                        id="fileUploadInput"
                        hidden
                        multiple
                        onChange={(e) => {
                          if (e.target.files?.length) {
                            const newFiles = Array.from(e.target.files);
                            if (
                              uploadedFiles.length + newFiles.length > MAX_FILES
                            ) {
                              setUploadError(
                                `You can only upload up to ${MAX_FILES} files.`
                              );
                              return;
                            }
                            setUploadedFiles((prev) => [...prev, ...newFiles]);
                            setUploadError("");
                          }
                        }}
                      />
                    </div>

                    {/* Inline error */}
                    {uploadError && (
                      <div className="text-danger mt-2">{uploadError}</div>
                    )}

                    {/* Show uploaded files and API receipt images */}
                    {(uploadedFiles?.length > 0) && (
                      <div className="mt-2 text-start">

                        {uploadedFiles.map((file, idx) => (
                          <div
                            key={idx}
                            className="d-flex justify-content-between align-items-center mb-1"
                          >
                            <span>{file?.name}</span>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger"
                              onClick={() => {
                                setUploadedFiles((prev) => {
                                  const updated = prev.filter(
                                    (_, i) => i !== idx
                                  );
                                  if (
                                    updated.length <= MAX_FILES
                                  ) {
                                    setUploadError("");
                                  }
                                  return updated;
                                });
                              }}
                            >
                              <i className="fas fa-times cross-btn"></i>
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="text-end mt-4">
                <button
                  className="btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center btn-block"
                  disabled={!selectedCategory || !description?.trim()}
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CustomerSupport;
